import React__default from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { animated, useTrail, config } from 'react-spring';
import FormatsByType from '../DownloadManagerFormatsByType/index.js';

var AnimatedBox = animated(Box);
var DownloadManagerTypeLists = function (_a) {
    var loading = _a.loading, formatsByTypes = _a.formatsByTypes, _b = _a.onSelectFormat, onSelectFormat = _b === void 0 ? function () { } : _b, _c = _a.onSelectFormatFavorite, onSelectFormatFavorite = _c === void 0 ? function () { } : _c, formatsActionsAvailable = _a.formatsActionsAvailable, className = _a.className, id = _a.id, _d = _a.testId, testId = _d === void 0 ? "DownloadManagerTypeLists" : _d, KIcon = _a.KIcon;
    var trail = useTrail(formatsByTypes.length, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        config: config.gentle
    });
    if (loading) {
        return (React__default.createElement(Box, { "data-testid": testId, id: id, className: clsx(className, "DownloadManagerTypeLists", "DownloadManagerTypeLists-loading") },
            React__default.createElement(FormatsByType, { loading: true })));
    }
    return (React__default.createElement(Box, { "data-testid": testId, id: id, className: clsx(className, "DownloadManagerTypeLists") }, trail.map(function (styles, i) {
        var formatsByType = formatsByTypes[i];
        return (React__default.createElement(AnimatedBox, { key: formatsByType.type, style: styles },
            React__default.createElement(FormatsByType, { formatsByType: formatsByType, onSelectFormat: onSelectFormat, onSelectFormatFavorite: onSelectFormatFavorite, formatsActionsAvailable: formatsActionsAvailable, single: formatsByTypes.length === 1, KIcon: KIcon })));
    })));
};

export { DownloadManagerTypeLists as default };
//# sourceMappingURL=index.js.map
